import React from 'react';
import '../App.css';
import './About.css';
import PageSections from '../site-content/PageSections';
import { useSitePage } from '../site/useSitePage';

function AboutPage() {
  const site = useSitePage('about');
  if (site.status === 'loading') return <div className="page-hero" aria-hidden="true" />;
  return <PageSections slug="about" sections={site.status === 'ready' ? site.sections : undefined} />;
}

export default AboutPage;
